import { Phone } from "lucide-react";
import { CONTACT } from "../data/content";
import { useLang } from "../i18n";
import { Flag } from "./Flagify";

export const WhatsAppIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17.5 14.4c-.3-.1-1.8-.9-2-1-.3-.1-.5-.1-.7.1-.2.3-.8 1-.9 1.2-.2.2-.3.2-.6.1-.3-.1-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6l.5-.6c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5l-.9-2.2c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.1.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.8-.7 2-1.4.2-.7.2-1.3.2-1.4-.1-.2-.3-.3-.6-.4zM12 2C6.5 2 2 6.5 2 12c0 1.8.5 3.5 1.3 5L2 22l5.2-1.4c1.4.8 3.1 1.2 4.8 1.2 5.5 0 10-4.5 10-10S17.5 2 12 2zm0 18.2c-1.5 0-3-.4-4.3-1.2l-.3-.2-3.1.8.8-3-.2-.3C4.1 15 3.7 13.5 3.7 12c0-4.6 3.7-8.3 8.3-8.3s8.3 3.7 8.3 8.3-3.7 8.2-8.3 8.2z" />
  </svg>
);

export const PhoneLinks = ({ prefix = "phone", className = "" }) => {
  const { t } = useLang();
  return (
    <ul className={`space-y-2 ${className}`}>
      {CONTACT.phones.map((p, i) => {
        const digits = p.number.replace(/\D/g, "");
        return (
          <li key={p.number} className="flex items-center gap-2.5" data-testid={`${prefix}-${i}`}>
            <Flag code={p.country.toLowerCase()} />
            <span className="font-mono2 text-[10px] tracking-wider text-[#5E7280]">{p.country}</span>
            <span className="text-sm font-medium text-[#0E1B24]">{p.number}</span>
            <span className="flex items-center gap-1">
              {p.whatsapp && (
                <a href={`https://wa.me/${digits}?text=${encodeURIComponent(t.hub.prefill)}`} target="_blank" rel="noopener noreferrer" data-testid={`${prefix}-${i}-whatsapp`} title={t.hub.whatsapp} aria-label={`WhatsApp ${p.number}`} className="flex h-7 w-7 items-center justify-center bg-[#25D366]/15 text-[#25D366] transition-colors hover:bg-[#25D366] hover:text-white">
                  <WhatsAppIcon size={15} />
                </a>
              )}
              {p.call && (
                <a href={`tel:+${digits}`} data-testid={`${prefix}-${i}-call`} title={t.hub.call} aria-label={`${t.hub.call} ${p.number}`} className="flex h-7 w-7 items-center justify-center bg-[#0F5C8C]/15 text-[#0F5C8C] transition-colors hover:bg-[#0F5C8C] hover:text-white">
                  <Phone size={14} />
                </a>
              )}
            </span>
          </li>
        );
      })}
    </ul>
  );
};
